import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "comment" }
const _hoisted_2 = ["innerHTML"]


import { UserOutlined } from '@ant-design/icons-vue'
import Filelist from '@/components/service/Filelist.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Comments',
  props: {
  comments: Array
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_comment = _resolveComponent("a-comment")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.comments, (comment) => {
      return (_openBlock(), _createBlock(_component_a_comment, {
        key: comment.id
      }, {
        author: _withCtx(() => [
          _createTextVNode(_toDisplayString(['employee', 'solver'].includes(comment.user.type) ? 'Medewerker' : comment.user.name), 1)
        ]),
        avatar: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            shape: "square",
            size: "large",
            style: { backgroundColor: '#f38929', fontSize: '18px', verticalAlign: 'middle' }
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(UserOutlined))
            ]),
            _: 1
          })
        ]),
        datetime: _withCtx(() => [
          _createVNode(_component_a_tooltip, {
            title: new Date(comment.created).toLocaleString('nl-NL')
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(comment.ago), 1)
            ]),
            _: 2
          }, 1032, ["title"])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", {
            style: {"margin-bottom":"8px"},
            innerHTML: comment.body
          }, null, 8, _hoisted_2),
          (comment.media.length)
            ? (_openBlock(), _createBlock(Filelist, {
                key: 0,
                media: comment.media
              }, null, 8, ["media"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_divider)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})